<template lang='pug'>
.articleCardSlider
  .articleCardSlider-arrows.show--bigScreens
    .articleCardSlider-left(@click='$refs.slick.prev()')
      .icon-slide-left
    .articleCardSlider-right(@click='$refs.slick.next()')
      .icon-slide-right
  Slick.articleCard-list(:options='slickOptions' ref='slick' @afterChange='changeIndex')
    VerifiedArticle(v-if="infos && infos.length > 0"
      v-for='(info, idx) in infos'
      :key='idx'
      :idx='idx + 1'
      :info='info'
    )
</template>

<script>

import VerifiedArticle from '@/components/verified_articles/verified_article.vue'
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import { getRouteByParam } from '@/plugins/tool.js'
import Slick from 'vue-slick';

export default {
  props: {
    params: Object
  },
  components: {
    VerifiedArticle,
    SectionTitle,
    Slick
  },
  data() {
    return {
      infos: [],
      typeDict: {},
      slideIndex: 1,
      length: 0,
      slickOptions: {
        slidesToShow: 1,
        swipeToSlide: true,
        variableWidth: true,
        centerMode: false,
        infinite: true,
        arrows: false,
        autoplay: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        draggable: true,
        edgeFriction: 0.30,
        swipe: true
      }
    }
  },
  async created() {
    this.typeDict.verifiedPartner = this.$store.state.routes.verifiedArticles
    this.typeDict.verifiedGov = this.$store.state.routes.govAnnounces
    await this.getInfo('verifiedPartner')
    await this.getInfo('verifiedGov')
    this.length = this.infos.length
    this.$emit('getData', {
      length: this.length
    })
  },
  watch: {
    infos: function () {
      let currIndex = this.$refs.slick.currentSlide()
      this.$refs.slick.destroy()
      this.$nextTick(() => {
        this.$refs.slick.create()
        this.$refs.slick.goTo(currIndex, true)
      })
    },
  },
  methods: {
    async getInfo(type) {
      let route = this.$store.state.URLs.api + '/' + this.$store.state.lang + this.typeDict[type]
      route = getRouteByParam(this.params[type], route)
      let result = await this.$axios.get(route)

      let infos = (Object.values(result.data.content))
      infos.forEach(info => {
        info.type = type
        this.infos.push(info)
      })
    },
    changeIndex() {
      this.slideIndex = this.$refs.slick.currentSlide() + 1
      this.$emit('slide', {
        idx: this.slideIndex
      })
    }
  }
}
</script>
